// Watch configurator

$(document).ready(function () {

  $('.slider').on('init', function (event, slick, currentSlide) {
    // Affichage du cadran
    $(".cadran").addClass("displayed");
  });

  // Bracelet slider
  $('.slider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    speed: 400,
    arrow: true,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });

  // Au changement de bracelet...
  $('.slider').on('afterChange', function (event, slick, currentSlide) {
    // Mise à jour des prix et noms
    updateNamesAndPrices();
  });

  // Au changement de cadran...
  $("#face_type").change(function () {
    var current_cadran = $(this).val();
    $(".cadran > div").fadeOut(250); // Fait disparaître le cadran actuel
    setTimeout(function () {
      $(".cadran > div[data-target=" + current_cadran + "]").fadeIn(250); // Fait apparaître le nouveau cadran
    }, 250);

    // Mise à jour des prix et noms
    updateNamesAndPrices();
  });

  // Au changement de types de bracelet...
  $("#bracelet_choice span").click(function () {
    var bracelet_filter = $(this).data("collection");
    $("#bracelet_choice span").removeClass("active");
    $(this).addClass("active");

    var slide_index = $('.' + bracelet_filter).not('.slick-cloned').data("slick-index");

    $('.slider').slick('slickGoTo', parseInt(slide_index));

    // Mise à jour des prix et noms
    updateNamesAndPrices();
  });

  // Mise à jour des noms et prix
  function updateNamesAndPrices() {
    var current_cadran = $('#face_type').val();

    var cadran_name = $(".cadran > div[data-target=" + current_cadran + "]").attr("data-name"); // Récupère le nom du cadran en cours
    var bracelet_name = $('.slick-current').attr("data-name"); // Récupère le nom du bracelet en cours
    var cadran_price = parseInt($(".cadran > div[data-target=" + current_cadran + "]").attr("data-price")); // Récupère le prix du cadran en cours
    var bracelet_price = parseInt($('.slick-current').attr("data-price")); // Récupère le prix du bracelet en cours
    var bracelet_id = parseInt($('.slick-current').attr("data-variant_id")); // Récupère l'ID du bracelet en cours
    var cadran_id = parseInt($(".cadran > div[data-target=" + current_cadran + "]").attr("data-variant_id")); // Récupère l'ID du cadran en cours

    $("#price_total").html(cadran_price + bracelet_price); // Mise à jour du prix total
    $("#price_bracelet").html(bracelet_price); // Mise à jour du prix du bracelet seul
    $(".face_details span").html(cadran_name); // Update le nom du cadran
    $(".bracelet_details span").html(bracelet_name); // Update le nom du bracelet
    $("#bracelet_id").val(bracelet_id); // Met à jour l'id du bracelet pour le cart
    $("#cadran_id").val(cadran_id); // Met à jour l'id du cadran pour le cart
  }

  // Initialisation
  function initWatches() {
    // Mise à jour des prix et noms
    updateNamesAndPrices();
  }

  // Ajout des produits multiples au panier
  $('button[data-action=add-to-cart-full]').click(function (e) {
    e.preventDefault();

    var products = [];
    $('input[data-id]').each(function (k) {
      products.push({ id: $(this).val(), quantity: $(this).data("quantity") }); // Parcourt tous les produits contenant un data-id
    })

    jQuery.post('/cart/add.js', {
      items: products
    }, function (result) {
      update_header_cart();
    }, 'json');

  });

  // Ajout d'un bracelet simple au panier
  $('button[data-action=add-to-cart-single]').click(function (e) {
    e.preventDefault();

    var products = [];
    const quantity = $(this).data("quantity");
    $('input[data-single]').each(function (k) {
      products.push({ id: $(this).val(), quantity }); // Parcourt tous les produits contenant un data-id
    })

    jQuery.post('/cart/add.js', {
      items: products
    }, function (result) {
      update_header_cart();
    }, 'json');

  });

  initWatches();

});
